import { useAuthUser } from "../../auth/hooks/useAuthUser";

export function useMaxAutotradeBots() {
  const { user } = useAuthUser();
  // return false;
  return user?.candefi_membership?.plan?.max_autotrade_bots || 0;
}